import Vue from 'vue';

// 动画指令
Vue.directive('animate-on-scroll', {
    inserted: function(el, binding) {
        const {
            value = 'fadeIn',
            modifiers = {}
        } = binding;
        let animation = value;
        let config = {};

        if (typeof value === 'string' && value.includes(':')) {
            const parts = value.split(':');
            animation = parts[0];
            for (let i = 1; i < parts.length; i += 2) {
                if (parts[i + 1] !== undefined) {
                    config[parts[i]] = parts[i + 1];
                }
            }
        }
        el.style.opacity = '0';
        el.style.transition = 'opacity 0.3s ease';

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 1.添加动画类
                        el.style.opacity = '1';
                        el.classList.add('animate__animated', `${animation}`);
                        // 2.应用配置
                        if (config.delay) el.classList.add(`animate__delay-${config.delay}s`);
                        if (config.speed) el.classList.add(`animate__${config.speed}`);
                        if (modifiers.infinite) el.classList.add('animate__infinite');
                        // 如果不需要重复触发，停止观察
                        if (!modifiers.repeat) {
                            observer.unobserve(el);
                        }
                    } else if (modifiers.repeat && !el.classList.contains('animate__infinite')) {
                        // 3.如果需要重复触发，滚动离开时重置
                        el.style.opacity = '0';
                        el.classList.remove('animate__animated', `${animation}`,
                            `animate__delay-${config.delay}s`, `animate__${config.speed}`);
                    }
                });
            },
            {
                root: null,
                threshold: parseFloat(config.threshold) || 0.1,
                rootMargin: config.rootMargin || '0px 0px -50px 0px'
            }
        );

        observer.observe(el);
        el.__animateObserver = observer;
    },

    unbind: function(el) {
        if (el.__animateObserver) {
            el.__animateObserver.unobserve(el);
            delete el.__animateObserver;
        }
    }
});
